// Shared list of aircraft manufacturers
export const aircraftManufacturers = {
  1: 'Boeing',
  2: 'Airbus',
  3: 'Embraer',
  4: 'Bombardier',
  5: 'ATR',
  6: 'Sukhoi',
  7: 'Tupolev',
  8: 'Ilyushin',
  9: 'Antonov',
  10: 'Cessna',
  11: 'Dassault',
  12: 'Gulfstream',
  13: 'Fokker',
  14: 'Yakovlev',
  99: 'Other'
};
